// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.practicepreferences.ConnectPracticeResponse */
/* istanbul ignore next */
@GandalfModel
export class ConnectPracticeResponse extends GandalfModelBase {

	@GandalfConstantDecorator(constants.A2pCampaignStatus)
	@GandalfProperty({ designType: constants.A2pCampaignStatus })
	a2pCampaignStatus!: constants.A2pCampaignStatus | null;

	@GandalfProperty({ designType: String })
	a2pRegistrationErrors!: string | null;

	@GandalfConstantDecorator(constants.A2pRegistrationStatus)
	@GandalfProperty({ designType: constants.A2pRegistrationStatus })
	a2pRegistrationStatus!: constants.A2pRegistrationStatus | null;

	@GandalfProperty({ designType: String })
	businessName!: string | null;

	@GandalfConstantDecorator(constants.ConnectBusinessType)
	@GandalfProperty({ designType: constants.ConnectBusinessType })
	connectBusinessType!: constants.ConnectBusinessType | null;

	@GandalfConstantDecorator(constants.ConnectCompanyType)
	@GandalfProperty({ designType: constants.ConnectCompanyType })
	connectCompanyType!: constants.ConnectCompanyType | null;

	@GandalfProperty({ designType: String })
	connectFein!: string | null;

	@GandalfProperty({ designType: Number })
	connectPracticeId!: number | null;

	@GandalfProperty({ designType: String })
	connectWebsite!: string | null;

	@GandalfProperty({ designType: Boolean })
	hasEnabledConnectSubscription!: boolean;

	@GandalfConstantDecorator(constants.StockExchange)
	@GandalfProperty({ designType: constants.StockExchange })
	stockExchange!: constants.StockExchange | null;

	@GandalfProperty({ designType: String })
	stockTicker!: string | null;

}
